export default "__VITE_ASSET__C1mdD64J__"